import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { AutoUploadOnboardingDialogProps } from './AutoUploadOnboardingDialog.types';

export const openAutoUploadOnboadingDialog = (data?: AutoUploadOnboardingDialogProps) =>
    openPopupHelper({ popupName: popupNames.AUTOUPLOAD_ONBOADING, data, onClose: data?.onClose });
export const closeAutoUploadOnboadingDialog = () => closePopupHelper(popupNames.AUTOUPLOAD_ONBOADING);
